// extracted by mini-css-extract-plugin
module.exports = {"pointer":"action_pointer__aWaZa","pointerEvent":"action_pointerEvent__11qDt","svgExternal":"action_svgExternal__1XC43","custom-dropdown":"action_custom-dropdown__FodLQ"};